import { Icon } from '@/general/Icons/Icon';
import { clsx } from 'clsx';
import { FC } from 'react';

import { formatNumber } from '@/general/helpers/formatNumber';
import { BaseCarData } from '@/types/Car.types';

interface Props {
  carData: BaseCarData;
  className?: string;
}

const carDetails: {
  title: string;
  valueKey: keyof BaseCarData;
  formatter?: (value: any) => string;
}[] = [
  {
    title: 'Odometer',
    valueKey: 'kilometers',
    formatter: (value) => formatNumber(value, { append: ' km' }),
  },
  {
    title: 'Fuel type',
    valueKey: 'fuelType',
  },
  {
    title: 'Transmission',
    valueKey: 'transmission',
  },
];

function carDetailIcon(title: string) {
  switch (title) {
    case 'Odometer':
      return <Icon name="meter" size={20} />;
    case 'Fuel type':
      return <Icon name="petrol" size={20} />;
    case 'Transmission':
      return <Icon name="automatic-transmission" size={20} />;
    default:
      return null;
  }
}

export const CarPriceCardDetails: FC<Props> = ({ carData, className }) => (
  <dl className={clsx('mt-2 flex items-start justify-center gap-5', className)}>
    {carDetails.map(({ title, valueKey, formatter }) => (
      <div key={title} className="inline-flex items-center justify-start gap-0.5">
        <dt className="flex h-5 text-lg">{carDetailIcon(title)}</dt>
        <dd className="c-fs-caption m-0 font-normal">{formatter ? formatter(carData[valueKey]) : carData[valueKey]}</dd>
      </div>
    ))}
  </dl>
);
